import FJStepHeader from './FJStepHeader';
import { useDispatch, useSelector } from 'react-redux';
import useLocalStore from '../../../hooks/useLocalStore';
import FJActionTextToVideo from '../../../redux/action/FJActionTextToVideo';
import FJConstant from '../../../constants/FJConstant';
import PropTypes from 'prop-types';
const FJStepHeaderContainer = props => {
    useLocalStore();
    const dispatch = useDispatch();
    const textToVideoStep = useSelector(state => state.textToVideo.textToVideoStep);
    const textToVideoStepList = useSelector(state => state.textToVideo.textToVideoStepList);
    const { className } = props;
    const onChangeStep = step => {
        const currentStepIdx = textToVideoStepList.findIndex(item => item.type === textToVideoStep);
        const newStepIdx = textToVideoStepList.findIndex(item => item.type === step);
        if (newStepIdx >= currentStepIdx) {
            return;
        }
        dispatch(FJActionTextToVideo.onStepChangeAction(step));
    };
    const gotoBack = () => {
        const preStep = textToVideoStepList.findIndex(item => item.type === textToVideoStep);
        if (preStep > 0) {
            onChangeStep(textToVideoStepList[preStep - 1].type);
        }
    };
    if (textToVideoStep === FJConstant.STEP_TYPE_HOME) {
        return null;
    }
    return (
        <FJStepHeader
            onChangeStep={onChangeStep}
            curStep={textToVideoStep}
            stepList={textToVideoStepList}
            gotoBack={gotoBack}
            className={className}
        />
    );
};

FJStepHeaderContainer.propTypes = {
    className: PropTypes.object,
};

export default FJStepHeaderContainer;
